import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalCustomComponent } from '@app/shared/modal-custom/modal-custom.component';

@Component({
  selector: 'mnf-modal-stp-pending',
  templateUrl: './modal-stp-pending.component.html',
  styleUrls: ['./modal-stp-pending.component.scss']
})
export class ModalStpPendingComponent {

  regProm: string;

  constructor(private modalRef: MatDialogRef<ModalCustomComponent>) {}

  accept() {
    this.modalRef.close(true);
  }


}
